import AddressAutocomplete from "../atoms/AddressAutocomplete";
import React from "react";
import getCounty from "../util/getCounty";
import getPropertyType from "../util/getPropertyType";

export const UswfAddressAutoComplete = ({
  placesService,
  isGoogleApiLoaded,
  googleMap,
  setState,
  setAddress,
}) => {
  return (
    <AddressAutocomplete
      isGoogleApiLoaded={isGoogleApiLoaded}
      onSelection={(selection) => {
        placesService.getDetails(
          { placeId: selection.place_id },
          async (response) => {
            const { location } = response.geometry;
            const street = selection.structured_formatting.main_text;
            const locality = response.address_components.find((item) =>
              item.types.includes("locality")
            );
            const neighborhoodObj = response.address_components.find((item) =>
              item.types.includes("neighborhood")
            );
            const city = locality.long_name;
            const neighborhood = neighborhoodObj?.long_name;
            const stateObj = response.address_components.find((item) =>
              item.types.includes("administrative_area_level_1")
            );
            const state = stateObj.short_name;
            const zipObj = response.address_components.find((item) => {
              return item.types.includes("postal_code");
            });
            const zip = zipObj?.long_name;

            // Get latitude and longitude for county lookup
            const lat = location.lat();
            const lng = location.lng();
            const { county, countyFips, stateFips } = await getCounty(
              response.address_components,
              lat,
              lng
            );

            // Fetch property type
            const propertyType = await getPropertyType(street, zip);

            new google.maps.Marker({
              position: location,
              map: googleMap,
              title: "My Home",
            });
            setState({
              mapHeight: 300,
              center: location,
              showMap: "expand",
            });

            const address = {
              county,
              countyFips,
              stateFips,
              street,
              city,
              state,
              zip: zipObj?.long_name,
              propertyType,
              neighborhood,
            };

            setAddress(address);
          }
        );
      }}
    />
  );
};
